import AvatarAPIService from "../avatar_api_service";
import apiUtils from "../../../../core/utils/api_utils";

export default class AvatarAPIServiceImpl extends AvatarAPIService {
  static #instance = null;

  constructor() {
    if (AvatarAPIServiceImpl.#instance) {
      return AvatarAPIServiceImpl.#instance;
    }

    super();
    AvatarAPIServiceImpl.#instance = this;
  }

  async getAvatarDetails({ key, value }) {
    if (!key) throw new Error("Please provide valid Avatar key.");

    try {
      const response = await apiUtils.get(`/api/avatars/${key}/${value}`);
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  }
}
